<input id="file" class="hide" #file name="file"
  accept="image/*,.doc, .docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/pdf"
  type="file" name="file" (change)="selectFile($event.target)" />

<form [formGroup]="dataFormEsp" (ngSubmit)="submit()" class="ion-text-center form-content">
  <ion-grid [fixed]="true">
    <ion-row>
      <ion-col size="12">
        <!-- Profesional de la salud -->
        <ion-grid class="ion-no-padding">
          <ion-row>
            <!-- Nivel educativo solo para profesional-de-la-salud -->
            <ion-col size="12" class="form-item">
              <ion-item lines="none" class="item-round ion-margin-bottom" color="light"
                style="--inner-padding-end: 0; --padding-start: 0;">
                <ion-icon color="primary" slot="start" name="layers-outline" style="margin-left: 16px;"></ion-icon>
                <div style="flex: 1; padding: 16px 16px 16px 0;">
                  <div style="margin-bottom: 12px;">
                    <ion-label style="font-weight: bold; font-size: 16px;">Nivel educativo</ion-label>
                  </div>
                  <ion-radio-group formControlName="educationalLevel">
                    <!-- <ion-radio-group formControlName="educationalLevel" (ionChange)="onEducationalLevelChange($event)"></ion-radio-group> -->
                    <ion-item lines="none"
                      style="--background: transparent; --padding-start: 0; --inner-padding-end: 0; --min-height: 40px; margin-bottom: 8px;"
                      *ngFor="let option of educationalLevelOptions">
                      <ion-radio [disabled]="true" labelPlacement="fixed" [value]="option.value">{{ option.label
                        }}</ion-radio>
                    </ion-item>
                  </ion-radio-group>
                </div>
              </ion-item>
              <ion-text color="danger"
                *ngIf="dataFormEsp.get('educationalLevel').touched && dataFormEsp.get('educationalLevel').getError('required')"
                class="item-with-error">
                <span class="ion-padding">El nivel educativo es requerido</span>
              </ion-text>
            </ion-col>
            <!-- Documento validador -->
            <ion-col size="12" class="form-item ion-margin-bottom">
              <ion-item lines="none" class="item-round" color="light">
                <ion-label>Documento de acreditación</ion-label><ion-buttons slot="end">
                  <ion-button (click)="openFile(userData?.verificationFileUrl)">
                    <ion-icon name="document-attach-outline" slot="icon-only"></ion-icon>
                  </ion-button>
                </ion-buttons>
              </ion-item>
            </ion-col>
            <!-- <ion-col size="12" class="form-item ion-margin-bottom"
              *ngIf="dataFormEsp?.value?.educationalLevel == 'estudiante' || dataFormEsp?.value?.educationalLevel == 'tecnico'">
              <ion-item lines="none" class="item-round" color="light">
                <ion-icon color="primary" slot="start" name="document-outline" size="small"></ion-icon>
                <label color="medium">Documento de acreditación
                  <ion-button style="margin-top: -10px;" fill="clear" shape="round" color="dark"
                    (click)="showTooltip($event,'Cargue un documento que acredite sus estudios ej. credencial, matrícula (pdf o imagen)')">
                    <ion-icon slot="icon-only" name="help-circle-outline"></ion-icon>
                  </ion-button>
                </label>
                <ion-button expand="block" fill="clear" shape="round" [disabled]="isLoading === true"
                  (click)="presentActionSheet()">
                  Seleccionar
                </ion-button>
              </ion-item>
              <ion-text color="primary" *ngIf="dataFormEsp?.get('verificationFile')?.value">
                <ion-icon class="icon-top" color="success" name="checkmark-circle-outline"></ion-icon>
                <small>Documento cargado</small>
              </ion-text>
              <ion-text color="danger"
                *ngIf="dataFormEsp.get('verificationFile').touched && dataFormEsp.get('verificationFile').getError('required')">
                <span class="ion-padding">El documento es requerido</span>
              </ion-text>
            </ion-col> -->
            <!-- tiempo que le falta para terminar sus estudios -->
            <ion-col size="12" class="form-item" *ngIf="dataFormEsp?.value?.educationalLevel == 'estudiante'">
              <ion-item lines="none" class="item-round" color="light">
                <ion-icon color="primary" slot="start" name="calendar-outline"></ion-icon>
                <ion-select [label]="selectLabel" formControlName="estimatedGraduationTime"
                  placeholder="Seleccione el plazo que resta para concluir sus estudios" (click)="onSelectOpen()"
                  (ionDismiss)="onSelectClose()">
                  <ion-select-option *ngFor="let option of estimatedGraduationTimeOptions" [value]="option?.value">{{
                    option?.label }}</ion-select-option>
                </ion-select>
              </ion-item>
              <ion-text color="danger"
                *ngIf="dataFormEsp.get('estimatedGraduationTime').touched && dataFormEsp.get('estimatedGraduationTime').getError('required')">
                <span class="ion-padding">Seleccione el plazo que resta para concluir sus estudios</span>
              </ion-text>
            </ion-col>
            <!-- Cédula profesional -->
            <ion-col size="12" class="form-item" *ngIf="dataFormEsp?.value?.educationalLevel == 'universitario'">
              <ion-item lines="none" class="item-round" color="light">
                <ion-icon color="primary" slot="start" name="id-card-outline" size="small"></ion-icon>
                <ion-input type="text" formControlName="cedula" placeholder="Ingrese cédula profesional"
                  size="small"></ion-input>
              </ion-item>
              <ion-text color="danger"
                *ngIf="dataFormEsp.get('cedula').touched && dataFormEsp.get('cedula').getError('required')">
                <span class="ion-padding">Cédula profesional es obligatoria</span>
              </ion-text>
            </ion-col>
          </ion-row>
        </ion-grid>
      </ion-col>
    </ion-row>
  </ion-grid>
  <div class="form-buttons">
    <ion-grid fixed>
      <ion-row>
        <ion-col size="12">
          <!-- <ion-button expand="block" type="submit" color="tertiary"
            [disabled]="!dataFormEsp.valid === true || isLoading === true">
            {{ button }}
          </ion-button> -->
          <ion-button expand="block" type="submit" color="tertiary"
            [disabled]="true">
            {{ button }}
          </ion-button>
        </ion-col>
      </ion-row>
    </ion-grid>
  </div>
</form>